import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"robot-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 14C3 9.58172 6.58172 6 11 6H13C17.4183 6 21 9.58172 21 14C21 18.4183 17.4183 22 13 22H11C6.58172 22 3 18.4183 3 14Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.9911 16.25H8.00839C7.11543 16.25 6.32454 15.6545 6.27173 14.7631C6.14998 12.7081 6.72828 9.25 11.9997 9.25C17.2711 9.25 17.8495 12.708 17.7277 14.7631C17.675 15.6545 16.8841 16.25 15.9911 16.25Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3C12.5523 3 13 2.55228 13 2C13 1.44772 12.5523 1 12 1C11.4477 1 11 1.44772 11 2C11 2.55228 11.4477 3 12 3ZM12 3V6M3.06189 13C3.55399 9.05369 6.92038 6 11 6H13C17.0796 6 20.446 9.05369 20.9381 13M3.06189 13C3.02104 13.3276 3 13.6613 3 14C3 14.3387 3.02104 14.6724 3.06189 15M3.06189 13H2C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H3.06189M3.06189 15C3.55399 18.9463 6.92038 22 11 22H13C17.0796 22 20.446 18.9463 20.9381 15M20.9381 13C20.979 13.3276 21 13.6613 21 14C21 14.3387 20.979 14.6724 20.9381 15M20.9381 13H22C22.5523 13 23 13.4477 23 14C23 14.5523 22.5523 15 22 15H20.9381","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15.9911 16.25H8.00839C7.11543 16.25 6.32454 15.6545 6.27173 14.7631C6.14998 12.7081 6.72828 9.25 11.9997 9.25C17.2711 9.25 17.8495 12.708 17.7277 14.7631C17.675 15.6545 16.8841 16.25 15.9911 16.25Z","strokeLinejoin":"round","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M10.0008 13.0029V13.001H10.0027V13.0029H10.0008Z","strokeLinejoin":"round","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M14.0008 13.0029V13.001H14.0027V13.0029H14.0008Z","strokeLinejoin":"round","strokeWidth":"props.strokeWidth"}}]}]}]};

const Robot2 = Vue.extend<IconProps>({
  name: 'Robot2Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'robot-2',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Robot2;
